'use strict';

module.exports = [
  '$scope',
  '$state',
  '$http',
  'toastService',
  'translateFilter',
  '$uibModal',
  function ($scope, $state, $http, toastService, translateFilter, $uibModal) {
    /* ---------------------------------- Tabs ---------------------------------- */
    $scope.openTab = function (evt, tabName) {
      var i, tabcontent, tablinks;

      tabcontent = document.getElementsByClassName('news-bullettin--tabs--tabcontent');
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = 'none';
      }

      tablinks = document.getElementsByClassName('news-bullettin--tabs--tablinks');
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(' active', '');
      }

      document.getElementById(tabName).style.display = 'block';
      evt.currentTarget.className += ' active';

      $scope.getNews(tabName);
    };

    /* ----------------------------- News Bullettin ----------------------------- */
    $scope.stageNews = [];
    $scope.publishedNews = [];

    $scope.getNews = function (status) {
      var mainConfig = global.ngDroAstralSituationRecordMainConfig;
      var baseEndPointUrl = mainConfig.ApiUrl;
      var url = baseEndPointUrl + 'public-site-promotion-media';

      $http({
        method: 'GET',
        url: url,
        params: {
          status: status,
        },
        withCredentials: true,
      })
        .then(function successCallback(response) {
          if (status == 'STAGE') {
            $scope.stageNews = response.data;
          } else if (status == 'PUBLISHED') {
            $scope.publishedNews = response.data;
          }
        })
        .catch(function errorCallback(response) {
          console.log(response);
        });
    };

    $scope.deleteStageNews = function (id) {
      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler eliminare?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(function () {
        var mainConfig = global.ngDroAstralSituationRecordMainConfig;
        var baseEndPointUrl = mainConfig.ApiUrl;
        var url = baseEndPointUrl + 'public-site-promotion-media';

        $http({
          method: 'DELETE',
          url: url + '/' + id,
          withCredentials: true,
        })
          .then(function successCallback(response) {
            toastService.createSuccessToast('Media eliminato con successo');
            $scope.getNews('STAGE');
          })
          .catch(function errorCallback(response) {
            console.log(response);
            toastService.createErrorToast("Errore durante l'eliminazione del media");
          });
      });
    };

    $scope.deletePublishedNews = function (id) {
      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler eliminare?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(function () {
        var mainConfig = global.ngDroAstralSituationRecordMainConfig;
        var baseEndPointUrl = mainConfig.ApiUrl;
        var url = baseEndPointUrl + 'public-site-promotion-media';

        $http({
          method: 'DELETE',
          url: url + '/' + id,
          withCredentials: true,
        })
          .then(function successCallback(response) {
            toastService.createSuccessToast('Media eliminato con successo');
            $scope.getNews('PUBLISHED');
          })
          .catch(function errorCallback(response) {
            console.log(response);
            toastService.createErrorToast("Errore durante l'eliminazione del media");
          });
      });
    };

    $scope.publishStageNews = function (id) {
      var mainConfig = global.ngDroAstralSituationRecordMainConfig;
      var baseEndPointUrl = mainConfig.ApiUrl;
      var url = baseEndPointUrl + 'public-site-promotion-media';

      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler pubblicare?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function () {
          $http({
            method: 'GET',
            url: url + '/publish/' + id,
            withCredentials: true,
          })
            .then(function successCallback(response) {
              $scope.stageNews = $scope.stageNews.filter(function (image) {
                return image.id != id;
              });

              toastService.createSuccessToast('Media pubblicato con successo');

              $scope.getNews('STAGE');
            })
            .catch(function errorCallback(response) {
              console.log(response);
              toastService.createErrorToast('Errore durante la pubblicazione del media');
            });
        },
        function () {}
      );
    };

    $scope.unpublishPublishedNews = function (id) {
      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler nascondere?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function () {
          var mainConfig = global.ngDroAstralSituationRecordMainConfig;
          var baseEndPointUrl = mainConfig.ApiUrl;
          var url = baseEndPointUrl + 'public-site-promotion-media';

          $http({
            method: 'GET',
            url: url + '/unpublish/' + id,
            withCredentials: true,
          })
            .then(function successCallback() {
              $scope.stageNews = $scope.stageNews.filter(function (image) {
                return image.id != id;
              });

              toastService.createSuccessToast('Media nascosto con successo');

              $scope.getNews('PUBLISHED');
            })
            .catch(function errorCallback(response) {
              console.log(response);
              toastService.createErrorToast('Errore durante la pubblicazione del media');
            });
        },
        function () {}
      );
    };

    $scope.updateOrder = function () {
      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler riordinare?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function () {
          var mainConfig = global.ngDroAstralSituationRecordMainConfig;
          var baseEndPointUrl = mainConfig.ApiUrl;
          var url = baseEndPointUrl + 'public-site-promotion-media';

          $http({
            method: 'POST',
            url: url + '/update-order',
            data: $scope.publishedNews,
            withCredentials: true,
          })
            .then(function successCallback(response) {
              $scope.getNews('PUBLISHED');
              toastService.createSuccessToast('Ordine aggiornato con successo');
            })
            .catch(function errorCallback(response) {
              console.log(response);
              toastService.createErrorToast("Errore durante l'aggiornamento dell'ordine");
            });
        },
        function () {}
      );
    };

    $scope.newStageNews = {
      clazz: 'com.dromedian.jdro.datex2.domain.PublicSitePromotionMedia',
      description: '',
      order: null,
      mediaUrl: '',
    };

    $scope.resetNewStageNews = function () {
      $scope.newStageNews = {
        clazz: 'com.dromedian.jdro.datex2.domain.PublicSitePromotionMedia',
        description: '',
        order: null,
        mediaUrl: '',
      };
    };

    $scope.addStageNews = function () {
      var mainConfig = global.ngDroAstralSituationRecordMainConfig;
      var baseEndPointUrl = mainConfig.ApiUrl;
      var url = baseEndPointUrl + 'public-site-promotion-media';

      $http({
        method: 'POST',
        url: url,
        data: $scope.newStageNews,
        withCredentials: true,
      })
        .then(function successCallback(response) {
          $scope.resetNewStageNews();
          toastService.createSuccessToast('Media aggiunto con successo');

          $scope.getNews('STAGE');
        })
        .catch(function errorCallback(response) {
          console.log(response);
          toastService.createErrorToast("Errore durante l'aggiunta del media");
        });
    };

    $scope.editStageNews = function (news) {
      var mainConfig = global.ngDroAstralSituationRecordMainConfig;
      var baseEndPointUrl = mainConfig.ApiUrl;
      var url = baseEndPointUrl + 'public-site-promotion-media';

      $http({
        method: 'POST',
        url: url,
        data: news,
        withCredentials: true,
      })
        .then(function successCallback(response) {
          $scope.resetNewStageNews();
          toastService.createSuccessToast('Media modificato con successo');

          $scope.getNews('STAGE');
        })
        .catch(function errorCallback(response) {
          console.log(response);
          toastService.createErrorToast('Errore durante la modifica del media');
        });
    };

    $scope.getNews('STAGE');
    $scope.getNews('PUBLISHED');

    $scope.srcFromHtmlString = function (htmlString) {
      var tempIframe = document.createElement('div');
      tempIframe.innerHTML = htmlString;
      var iframe = tempIframe.querySelector('iframe');
      var src = iframe ? iframe.src : '';
      tempIframe.remove();

      return src;
    };

    /* ------------------------------ Drag and Drop ----------------------------- */
    var dragNewsId = null;

    $scope.handleDragStart = function (event, index) {
      event.originalEvent.srcElement.style.opacity = '0.4';

      dragNewsId = index;

      event.originalEvent.dataTransfer.effectAllowed = 'move';
      event.originalEvent.dataTransfer.setData('text/html', event.originalEvent.srcElement);
    };

    $scope.handleDragOver = function (event, index) {
      if (event.originalEvent.preventDefault) {
        event.originalEvent.preventDefault();
      }

      event.originalEvent.dataTransfer.dropEffect = 'move';

      return false;
    };

    $scope.handleDragEnter = function (event, index) {
      var elementWithDraggableAttribute =
        event.originalEvent.toElement.closest('[draggable="true"]');
      elementWithDraggableAttribute.classList.add('over');
    };

    $scope.handleDragLeave = function (event, index) {
      var elementWithDraggableAttribute =
        event.originalEvent.toElement.closest('[draggable="true"]');
      if (!elementWithDraggableAttribute.contains(event.originalEvent.relatedTarget)) {
        elementWithDraggableAttribute.classList.remove('over');
      }
    };

    $scope.handleDrop = function (event, index) {
      if (event.originalEvent.stopPropagation) {
        event.originalEvent.stopPropagation();
      }

      if (dragNewsId !== index) {
        var temp = $scope.publishedNews[index];
        $scope.publishedNews[index] = $scope.publishedNews[dragNewsId];
        $scope.publishedNews[dragNewsId] = temp;
      }

      return false;
    };

    $scope.handleDragEnd = function (event, index) {
      event.originalEvent.srcElement.style.opacity = '1';

      $scope.publishedNews = $scope.publishedNews.map(function (news, index) {
        news.order = index + 1;
        return news;
      });

      var items = document.querySelectorAll(
        '.news-bullettin--dnd--container .news-bullettin--dnd--box'
      );
      items.forEach(function (item) {
        item.classList.remove('over');
      });
    };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/newsBullettin/newsBullettinCtrl.js
// module id = 252
// module chunks = 0